module.exports = __webpack_public_path__ + "b10798a5c07962e68247bafa78620de8.svg";